import React from "react";
import Modal from "react-bootstrap/Modal";

function ViewImageModal({ imageUrl, bannerUrl, showModal, handleClose }) {
  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Only show the image */}
        <div className="ad-banner-image-preview">
          {imageUrl ? (
            <div className="ad-banner-image-preview-img-box">
              <img
                src={imageUrl}
                alt="preview"
                style={{
                  width: "100%",
                  height: "auto",
                  maxWidth: "100%",
                  maxHeight: "400px",
                }}
              />
            </div>
          ) : (
            <div className="ad-banner-image-preview-img-box">
              <p>Please upload a banner</p>
            </div>
          )}
          <a
            href={bannerUrl}
            aria-label="View banner in new tab"
            target="_blank"
            rel="noopener noreferrer"
            className="ad-banner-image-preview-link"
          >
            {bannerUrl}
          </a>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="bttn-close" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewImageModal;
